import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from "@mui/material";
import { Project } from "@snubes/snubes-types";
import { FC, useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../Common/helpers/handleError";
import { useT } from "../../Translation/hooks/useT";
import { deleteProjectCallable } from "../callables/deleteProjectCallable";

interface Props {
  project?: Project;
  isOpen: boolean;
  isNavigating?: boolean;
  close: () => void;
}

export const ProjectDeleteDialog: FC<Props> = (props) => {
  const t = useT();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deleteProject = useCallback(async () => {
    if (!props.project) return;

    try {
      setIsSubmitting(true);

      await deleteProjectCallable({
        projectId: props.project.id,
      });
      if (props.isNavigating) {
        navigate("/projects");
      }
      toast.success(t("ProjectDeleteDialog_Toast_SuccessMessage"));
    } catch (error) {
      handleError(error).logAnd().toast();
      setIsSubmitting(false);
    }
  }, [props.project, props.isNavigating, t, navigate]);

  return (
    <Dialog open={props.isOpen} onClose={props.close} fullWidth>
      <DialogTitle>{t("ProjectDeleteDialog_Title_DeleteProject")}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          {t("ProjectDeleteDialog_Content_DeleteProject")}
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          disabled={isSubmitting}
          onClick={(event) => {
            event.stopPropagation();
            props.close();
          }}
        >
          {t("ProjectDeleteDialog_Button_Cancel")}
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={isSubmitting}
          onClick={(event) => {
            event.stopPropagation();
            void deleteProject();
          }}
        >
          {t("ProjectDeleteDialog_Button_Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
